import { createContext, useEffect, useState, useContext } from "react";
import { getTenantSubdomain } from "../util/tenantUtil";
import tenantConfigs from "../config/tenantsConfig.json";
import LoadingOverlay from "../components/LoadingOverlay";
import { ConfigContext } from "./ConfigContext";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themeData, setThemeData] = useState(null);
  const { jwt } = useContext(ConfigContext);

  useEffect(() => {
    const tenant = getTenantSubdomain();
    // console.log("Tenant Found: ", tenant);
    const config = tenantConfigs[tenant] || tenantConfigs.default;
    // const config = tenantConfigs[tenant] ;
    // console.log("Cofig: ", config, "tenant: ", tenant);

    // Apply CSS variables
    const root = document.documentElement;
    const theme = config.theme;
    root.style.setProperty(
      "--color-loginCardBackground",
      theme.loginCardBackground
    );
    root.style.setProperty("--color-loginButtonColor", theme.loginButtonColor);
    root.style.setProperty(
      "--color-loginButtonHoverColor",
      theme.loginButtonHoverColor
    );
    root.style.setProperty(
      "--color-loginButtonTextColor",
      theme.loginButtonTextColor
    );
    root.style.setProperty(
      "--color-loginButtonHoverTextColor",
      theme.loginButtonHoverTextColor
    );
    root.style.setProperty(
      "--color-loginInputPlaceholderTextColor",
      theme.loginInputPlaceholderTextColor
    );
    root.style.setProperty(
      "--color-loginInputAreaBackgroundColor",
      theme.loginInputAreaBackgroundColor
    );
    root.style.setProperty(
      "--color-drawerButtonColor",
      theme.drawerButtonColor
    );
    root.style.setProperty(
      "--color-drawerHoverButtonColor",
      theme.drawerHoverButtonColor
    );
    root.style.setProperty(
      "--color-loginInputTypedTextColor",
      theme.loginInputTypedTextColor
    );
    root.style.setProperty(
      "--color-dashboardMenuBackgroundColor",
      theme.dashboardMenuBackgroundColor
    );
    root.style.setProperty(
      "--color-dashboardInactiveTabBackgroundColor",
      theme.dashboardInactiveTabBackgroundColor
    );
    root.style.setProperty(
      "--color-dashboardInactiveTabHoverBackgroundColor",
      theme.dashboardInactiveTabHoverBackgroundColor
    );
    root.style.setProperty(
      "--color-dashboardInactiveTabTextAndIconColor",
      theme.dashboardInactiveTabTextAndIconColor
    );
    root.style.setProperty(
      "--color-dashboardInactiveTabHoverTextAndIconColor",
      theme.dashboardInactiveTabHoverTextAndIconColor
    );
    root.style.setProperty(
      "--color-dashboardActiveTabBackgroundColor",
      theme.dashboardActiveTabBackgroundColor
    );
    root.style.setProperty(
      "--color-dashboardActiveTabTextAndIconColor",
      theme.dashboardActiveTabTextAndIconColor
    );
    setThemeData(config);
  }, [jwt]);

  if (!themeData) {
    return <LoadingOverlay type={1} />;
  }

  return (
    <ThemeContext.Provider value={themeData}>{children}</ThemeContext.Provider>
  );
};
